"use client"

import { Toast } from "@base-ui/react/toast"
import { CheckCircleIcon, XCircleIcon } from "@heroicons/react/20/solid"
import clsx from "clsx"
import type { ReactNode } from "react"

export function ToastList() {
  const { toasts } = Toast.useToastManager()

  return toasts.map((toast) => {
    const customIcon = (toast.data as { icon?: ReactNode } | undefined)?.icon

    return (
      <Toast.Root
        key={toast.id}
        toast={toast}
        swipeDirection={["up", "left", "right"]}
        className={clsx(
          "dark -outline-offset-1 absolute top-0 right-0 left-auto z-[calc(1000-var(--toast-index))] mx-auto mr-0 h-[--height] w-full origin-top cursor-default select-none rounded-2xl bg-gray-800 bg-clip-padding px-3.5 py-4 text-white shadow-md outline outline-gray-700 dark:bg-gray-950 dark:shadow-none dark:outline-white/5",

          "[--gap:0.5rem] [--height:var(--toast-frontmost-height,var(--toast-height))] [--offset-y:calc(var(--toast-offset-y)+(var(--toast-index)*var(--gap))+var(--toast-swipe-movement-y))] [--peek:0.75rem] [--scale:calc(max(0,1-(var(--toast-index)*0.1)))] [--shrink:calc(1-var(--scale))]",

          "transform-[translateX(var(--toast-swipe-movement-x))_translateY(calc(var(--toast-swipe-movement-y)+(var(--toast-index)*var(--peek))+(var(--shrink)*var(--height))))_scale(var(--scale))] [transition:transform_0.5s_cubic-bezier(0.22,1,0.36,1),opacity_0.5s,height_0.15s]",

          "data-expanded:transform-[translateX(var(--toast-swipe-movement-x))_translateY(var(--offset-y))] data-expanded:h-[--toast-height]",

          "data-starting-style:transform-[translateY(-150%)] data-ending-style:transform-[translateY(-150%)] data-ending-style:opacity-0",

          "data-limited:opacity-0",

          "data-ending-style:data-[swipe-direction=up]:transform-[translateY(calc(var(--toast-swipe-movement-y)-150%))]",
          "data-ending-style:data-[swipe-direction=left]:transform-[translateX(calc(var(--toast-swipe-movement-x)-150%))_translateY(var(--offset-y))]",
          "data-ending-style:data-[swipe-direction=right]:transform-[translateX(calc(var(--toast-swipe-movement-x)+150%))_translateY(var(--offset-y))]",
          "data-ending-style:data-[swipe-direction=down]:transform-[translateY(calc(var(--toast-swipe-movement-y)+150%))]",

          "after:absolute after:bottom-full after:left-0 after:h-[calc(var(--gap)+1px)] after:w-full after:content-['']"
        )}
      >
        <Toast.Content className="flex items-center justify-between gap-3">
          {customIcon}
          {!customIcon && toast.type === "success" && (
            <CheckCircleIcon className="size-6 shrink-0 text-green-500" />
          )}
          {!customIcon && toast.type === "error" && (
            <XCircleIcon className="size-6 shrink-0 text-red-400" />
          )}
          <div className="flex-1">
            <Toast.Title className="font-semibold text-base/4.5 text-white" />
            <Toast.Description className="mt-0.5 font-medium text-gray-400 text-sm/4" />
          </div>
        </Toast.Content>
      </Toast.Root>
    )
  })
}
